import React, { useState } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
<nav className="h-20 bg-black text-white px-6 py-4 pt-6 flex justify-between items-center sticky top-0 z-50">
{/* Logo */}
      <img src="/assets/images/ps-logo.png" alt="Pentomino Logo" className="h-10 w-10 object-contain" />
      <div className="text-2xl font-bold">Pentomino Solutions</div>

      {/* Desktop Menu */}
      <ul className="hidden md:flex space-x-14 text-lg">
        <li>
          <a href="/#" className="hover:text-green-400 cursor-pointer">Home</a>
        </li>
        <li>
          <a href="/#services" className="hover:text-green-400 cursor-pointer">Services</a>
        </li>
        <li>
          <a href="/edu-square" className="hover:text-green-400 cursor-pointer">Edu Square</a>
        </li>
        <li>
          <a href="/#contact" className="hover:text-green-400 cursor-pointer">Contact Us</a>
        </li>
        <li>
          <a href="/#about" className="hover:text-green-400 cursor-pointer">About Us</a>
        </li>
      </ul>

      <a href="#contact">
        <button className="bg-green-500 px-4 py-2 rounded-md hidden md:block hover:bg-green-400">
          Contact Us
        </button>
      </a>


      {/* Mobile Menu Toggle */}
      <div className="md:hidden z-20">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="text-white text-2xl"
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <ul className="absolute top-full right-0 w-1.9/3 bg-white text-right text-black space-y-4 py-4 px-6 text-lg z-10">
          <li className="hover:text-green-400 cursor-pointer">Home</li>
          <li className="hover:text-green-400 cursor-pointer">Services</li>
          <li className="hover:text-green-400 cursor-pointer">Edu Square</li>
          <li className="hover:text-green-400 cursor-pointer">Contact Us</li>
          <li className="hover:text-green-400 cursor-pointer">About Us</li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
